import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import App from "./App";
import { store } from "./app/store";
import "./styles/index.css";

// Apply the stored presentation prefs before first paint so the page never
// flashes light on its way to dark, or reflows once the font scale loads.
document.documentElement.dataset.theme =
  localStorage.getItem("ebmr.theme") || "light";
document.documentElement.dataset.fontScale =
  localStorage.getItem("ebmr.fontScale") || "md";
document.documentElement.lang = localStorage.getItem("ebmr.lang") || "en";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
